import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-office-home',
  templateUrl: './office-home.component.html',
  styleUrls: ['./office-home.component.scss']
})
export class OfficeHomeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
